import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm, useFieldArray, SubmitHandler } from "react-hook-form";
import StateContext from '../stateContext';
import axios from 'axios';

//import './trackApplication.css';

function TrackApplication() {

  // get state context
  const { userInfo, createNotification } = useContext(StateContext);

  const [ newListing, setNewListing ] = useState(
    {
      "company_name_full": "",
      "link": "",
      "job_title": "",
      "location": "",
      "job_description": ""
    }
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: newListing
  });

  async function trackNewListing(newListingData) {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/listing/create',
      {
        ...newListingData,
        "email": userInfo.email,
        "jwt": userInfo.jwt
      }
    ).then((response) => {
      if (response.status == 200 && response.data.success == true && response.data.results > 0) {
        createNotification({
          "status": "success",
          "msg": "Job Application tracked!",
        })

        // clear company name, job title, and link, to avoid duplicates
        setNewListing({
          ...newListing,
          "company_name_full": "",
          "link": "",
          "job_title": "",
        })
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Error tracking job application!",
        })
      }
    })
  }
  
  return (
    <main className="trackApplication">
      <nav class="appNav">
        <h2 style={{ margin: "0px"}}>Applications</h2>
        <Link 
        to="/applications/all"
        style={{
          backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
          padding: "5px 0px", textAlign: "center", borderRadius: "5px"
        }}>All</Link>
        <Link 
          to="/applications/unapplied"
          style={{
            backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
            padding: "5px 0px", textAlign: "center", borderRadius: "5px"
          }}>Unapplied</Link>
        <Link 
          to="/applications/not_interested"
          style={{
            backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
            padding: "5px 0px", textAlign: "center", borderRadius: "5px"
          }}>Uninterested</Link>
        <Link 
          to="/applications/too_far"
          style={{
            backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
            padding: "5px 0px", textAlign: "center", borderRadius: "5px"
          }}>Too far</Link>
        <Link 
          to="/applications/position_accepted"
          style={{
            backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
            padding: "5px 0px", textAlign: "center", borderRadius: "5px"
          }}>Accepted</Link>
        <Link 
          to="/applications/interviewing"
          style={{
            backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
            padding: "5px 0px", textAlign: "center", borderRadius: "5px"
          }}>Interviewing</Link>
        <Link 
          to="/applications/not_selected"
          style={{
            backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
            padding: "5px 0px", textAlign: "center", borderRadius: "5px"
          }}>Not Selected</Link>
        <Link 
          to="/applications/does_not_exist"
          style={{
            backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
            padding: "5px 0px", textAlign: "center", borderRadius: "5px"
          }}>Does not exist</Link>
      </nav>
      <form  onSubmit={handleSubmit(trackNewListing)}
        style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }}
      >
        <div className='input'>
          <label for="company_name_full" className="inputLabel">Company Name</label>
          <input {...register(`company_name_full`, { 
            required: "Company Name Required", 
            pattern: {
              value: /^[a-zA-Z.& 0-9]{3,}$/i, 
              message: "Valid Company Name required" 
            }})}
            placeholder="Company Name"/>
        </div>
        <div className='input'>
          <label for="link" className="inputLabel">Application URL</label>
          <input {...register(`link`, { 
            required: "Application URL needed!", 
            pattern: {
              value: /^.+[.].+[.].+$/i, 
              message: "Valid Application URL required" 
            }})} placeholder="Application URL"/>
        </div>
        <div className='input'>
          <label for="job_title" className="inputLabel">Job Title</label>
          <input {...register(`job_title`, { required: true })} placeholder="Job Title"/>
        </div>
        <div className='input'>
          <label for="location" className="inputLabel">Location</label>
          <input {...register(`location`, { required: true })} placeholder="Location"/>
        </div>
        <div className='input' >
          <label for="job_description" className="inputLabel">Job Description</label>
          <textarea 
          style={{
            height: "200px",
            resize: "none"
          }}
          {...register(`job_description`)} 
          placeholder="Job Description"/>
        </div>
        <button type="submit" className="submit">Track Application</button>
      </form>
    </main>
  )
}

export default TrackApplication;